require('./generateDataDictionaryModal.i18n.json');
require('./generateDataDictionaryModal.tpl.html');
require('./generateDataDictionaryRepository.js');

/*@ngInject*/
const GenerateDataDictionaryModalController = function ($rootScope, $scope, coreConstant, localization, modalUtil, configurationMediator, loadingBarHandler) {

    localization.getTranslationByKey('generateDataDictionary').then(function (translations) {
        $scope.viewModel = {
            title: translations.title,
            message: translations.message,
            confirmButton: translations.confirmButton,
            cancelButton: translations.cancelButton
        };

        $scope.onCancel = function () {
            $scope.$dismiss();
        };

        $scope.onConfirm = function () {
            $scope.$close();
            loadingBarHandler.showLoadingBar(translations.loadingBar);
            configurationMediator.generateDataDictionary().then(function () {
                loadingBarHandler.hideLoadingBar();
                $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, translations.successMessage);
            }, function () {
                // On Error
                loadingBarHandler.hideLoadingBar();
            });
        };

        $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
            $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
        });

        $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
    });
};

angular.module('ums.configuration')
    .controller('generateDataDictionaryModalController', GenerateDataDictionaryModalController);
